import React from 'react';
import {useNavigate,Link} from 'react-router-dom';
import avatar from '../../assets/img/avatars/avatar.png';
import { useSidebar } from '../../contexts/SidebarContext';


const Header = () => {
  const subDomain = localStorage.getItem('sub_domain');
  const navigate = useNavigate();
  const { toggleSidebar } = useSidebar();
  const logOut = (e) => {
    e.preventDefault();
    localStorage.clear();
    navigate("/login");
  }
  // Get role from localStorage
  const role = localStorage.getItem('role');

  // Map roles to dashboard titles
   const roleTitleMap = {
    admin: 'Admin',
    event: 'Event',
    finance: 'Finance',
    management: 'Management'
  };

  // Get title based on role, fallback to "Dashboard"
 const dashboardTitle =
  role === "event" && subDomain
    ? `${subDomain}.scientexconference.com`
    : `${roleTitleMap[role] || ""} Dashboard`;
  return (
    <nav className="navbar navbar-expand navbar-light navbar-bg">
     <Link className="sidebar-toggle js-sidebar-toggle" onClick={toggleSidebar}>
        <i className="hamburger align-self-center"></i>
      </Link>
      <h3 title={dashboardTitle}>{dashboardTitle}</h3>
      <div className="navbar-collapse collapse">
        <ul className="navbar-nav navbar-align">
          <li className="nav-item dropdown">
            <Link
              className="nav-icon pe-md-0 dropdown-toggle show"
              to="#"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              <img src={avatar} className="avatar img-fluid rounded" alt="John Doe" />
            </Link>
            <div className="dropdown-menu dropdown-menu-end" data-bs-popper="static">
              <Link to="#" className="dropdown-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user align-middle me-1" > <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path> <circle cx="12" cy="7" r="4"></circle> </svg>
                Profile
              </Link>
              <Link to="#" className="dropdown-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-help-circle align-middle me-1" > <circle cx="12" cy="12" r="10"></circle> <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path> <line x1="12" y1="17" x2="12.01" y2="17"></line> </svg>
                Help Center
              </Link> 
              <button className="dropdown-item d-flex align-items-center" type='button' onClick={logOut} title="Log out">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="me-2"
                viewBox="0 0 16 16"
              >
                <path d="M6 2a1 1 0 0 1 1-1h3.5A2.5 2.5 0 0 1 13 3.5v9A2.5 2.5 0 0 1 10.5 15H7a1 1 0 0 1-1-1v-1h1v1h3.5A1.5 1.5 0 0 0 12 12.5v-9A1.5 1.5 0 0 0 10.5 2H7v1H6V2z" />
                <path d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H9.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z" />
              </svg>
              Log out
            </button>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;